import {Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DadataTypes} from '../../interfaces/DadataTypes';
import {BehaviorSubject, Observable} from 'rxjs';
import {DadataService} from '../../services/dadata.service';
import {map, switchMap} from 'rxjs/operators';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DadataConfig, DadataConfigDefault} from './dadata-config';
import {DadataSuggestion} from '../../interfaces/DadataSuggestion';
import {NbAutocompleteModule, NbInputModule, NbOptionModule} from '@nebular/theme';
import {AsyncPipe, NgClass, NgFor} from '@angular/common';

@Component({
  selector: 'app-dadata',
  templateUrl: './dadata.component.html',
  styleUrls: ['./dadata.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DadataComponent),
      multi: true
    }
  ],
  imports: [NbInputModule, NbAutocompleteModule, NgClass, NgFor, NbOptionModule, AsyncPipe]
})
export class DadataComponent implements OnInit, OnChanges, ControlValueAccessor {

  suggestionData$: Observable<DadataSuggestion[]>;

  protected v: any = '';

  protected inputString$ = new BehaviorSubject<string>('');

  @Input() config: DadataConfig = DadataConfigDefault;
  @Input() type: DadataTypes = DadataConfigDefault.type;
  @Input() limit = DadataConfigDefault.limit;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() value = '';

  @Output() selected: EventEmitter<DadataSuggestion> = new EventEmitter<DadataSuggestion>();

  @ViewChild('inputValue', {static: true}) inputValue: ElementRef;

  onTouched = () => {
  };
  propagateChange = (_: any) => {
  };

  constructor(
    protected dadataService: DadataService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && this.inputValue) {
      this.inputValue.nativeElement.value = changes['value'].currentValue || '';
    }
  }

  ngOnInit(): void {
    this.suggestionData$ = this.inputString$
      .pipe(
        switchMap(x => this.dadataService.getSuggestion(x, this.config)),
        map(y => y.suggestions)
      );
  }

  getData(value: string) {
    this.selected.emit(null);
    this.inputString$.next(value);
  }

  onChange(e) {
    this.selected.emit(e);
    this.inputValue.nativeElement.value = e.value;
    this.propagateChange(e.value);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.v = obj;
    } else {
      this.v = '';
    }
  }

}
